import { memo } from 'react'

const HomeIcon: React.FC = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M1 16V5.33333L7.93333 0L14.8667 5.33333V16H9.66667V9.77778H6.2V16H1Z"
      fill="currentColor"
    />
  </svg>
))

export { HomeIcon }
